import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed w-full z-50 bg-dark/90 backdrop-blur-md border-b border-white/10" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="flex justify-between items-center h-24" data-id="element-232">
          <div className="flex-shrink-0 flex items-center" data-id="element-233">
            <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt="AS Elite Contractor Logo" className="h-16 md:h-20 w-auto object-contain" data-id="element-234" />
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-235">
            <a href="#servicios" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-236">
              Servicios
            </a>
            <a href="#portafolio" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-237">
              Portafolio
            </a>
            <a href="#nosotros" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-238">
              Nosotros
            </a>
            <a href="#resenas" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-239">
              Reseñas
            </a>
            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="bg-gold text-dark px-6 py-2.5 rounded-full font-bold text-sm hover:bg-gold-400 transition-all transform hover:scale-105" data-id="element-240">
              EMPIEZA HOY →
            </a>
          </div>

          <div className="md:hidden flex items-center" data-id="element-241">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-300 hover:text-white" data-id="element-242">
              {isOpen ? <X className="h-6 w-6" data-id="element-243" /> : <Menu className="h-6 w-6" data-id="element-244" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-dark-100 border-b border-white/10" data-id="element-245">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-246">
            <a href="#servicios" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-247">
              Servicios
            </a>
            <a href="#portafolio" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-248">
              Portafolio
            </a>
            <a href="#nosotros" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-249">
              Nosotros
            </a>
            <a href="#resenas" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-250">
              Reseñas
            </a>
            <a href="https://wa.me/447311754270?text=WEBSITE" className="block px-3 py-2 text-gold font-bold" data-id="element-251">
              EMPIEZA HOY →
            </a>
          </div>
        </div>}
    </nav>;
}